require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { createI18n } from "vue-i18n";
import UiInput from "@/Shared/UI/UiInput";
import UiButton from "@/Shared/UI/UiButton";
import UiModal from "@/Shared/UI/UiModal";
import UiSelect from "@/Shared/UI/UiSelect";
import UiAvatar from "./Shared/UI/UiAvatar";
import UiToggle from "./Shared/UI/UiToggle";
import UiDivider from "./Shared/UI/UiDivider";
import UiTextarea from "./Shared/UI/UiTextarea";
import UiCard from "./Shared/UI/UiCard";
import { Link } from "@inertiajs/inertia-vue3"

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const i18n = createI18n({
    locale: "es"
});

const el = document.getElementById('app');

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } })
            .use(i18n)
            .component('ui-input', UiInput)
            .component('ui-button', UiButton)
            .component('ui-modal', UiModal)
            .component('ui-select', UiSelect)
            .component('ui-avatar', UiAvatar)
            .component('ui-toggle', UiToggle)
            .component('ui-divider', UiDivider)
            .component('ui-textarea', UiTextarea)
            .component('ui-card', UiCard)
            .component('Link', Link)
            .mount(el);
    },
});

// createApp({
//     render: () =>
//         h(InertiaApp, {
//             initialPage: JSON.parse(el.dataset.page),
//             resolveComponent: (name) => require(`./Pages/${name}`).default,
//         }),
// })
//     .mixin({ methods: { route } })
//     .use(InertiaPlugin)
//     .use(i18n)
//     .component('ui-input', UiInput)
//     .component('ui-button', UiButton)
//     .component('ui-modal', UiModal)
//     .component('ui-select', UiSelect)
//     .component('ui-avatar', UiAvatar)
//     .component('ui-toggle', UiToggle)
//     .component('ui-divider', UiDivider)
//     .component('ui-textarea', UiTextarea)
//     .component('ui-card', UiCard)
//     .mount(el);

InertiaProgress.init({ color: '#00AEEF' });

// InertiaProgress.init({ color: '#4B5563' });